import { formatDateTime } from './formatDate';

export function getLabel(row: any, attributes: any, attribute: any) {
    let label = '';
    let value = '';
    try {
        for (let index = 0; index < Object.keys(row).length; index++) {
            const element = Object.keys(row)[index].valueOf();
            if (element === attribute) {
                Object.getOwnPropertyNames(attributes).forEach(
                    function (val) {
                        if (element === val) {
                            label = attributes[val];
                            return;
                        }
                    }
                );
                value = Object.values<any>(row)[index].valueOf();
                value = formatDateTime(value);
            }
        }
    } catch (error) {
        undefined;
    }
    return (
        { label: label, value: value }
    );
}

export function getAttribute(row: any, attribute: string, option: 'label' | 'value'): string {
    // Mapeamento de atributos para labels (caso você precise usar a opção 'label')
    const attributeLabels: { [key: string]: string } = {
        status: 'Status',
        creationDateTime: 'Data de Criação',
        statusId: 'ID do Status'
    };

    // Verifica se a opção é 'label' ou 'value'
    if (option === 'label') {
        return attributeLabels[attribute] || attribute; // Retorna o label se encontrado, senão retorna o próprio nome do atributo
    } else if (option === 'value') {
        return row[attribute] || ''; // Retorna o valor do atributo no objeto
    }

    return '';
}

// Exemplo de uso:
const row = { statusId: '1', status: 'new', creationDateTime: '2024-01-01' };